import sc from 'styled-components';

import {TextArea} from '@phonectas/unifon-ui-kit';

interface TextAreaProps {
    $fullWidth?: boolean;
}

export const StyledTextArea = sc(TextArea)<TextAreaProps>`
    padding: 8px;
    box-sizing: border-box;
`;
